import { Status } from 'apis/Status';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './ConfirmPopUp.css';

const ConfirmPopUp = (props) => {
  const { title, confirmText, cancelText, onConfirm, onCancel } = props;

  const pendingPolygonDelete = useSelector((state) => state.statuses?.['DELETE-User-DevicePolygon'] === Status.PENDING);

  const [clickedKeyCode, setClickedKeyCode] = useState(null);

  const handleKeyDown = (e) => {
    setClickedKeyCode(e.keyCode);
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown, false);

    return () => {
      window.removeEventListener('keydown', handleKeyDown, false);
    };
  }, []);

  useEffect(() => {
    // Cancel
    if (clickedKeyCode === 27) {
      onCancel();
    }

    // Enter
    if (clickedKeyCode === 13) {
      onConfirm();
    }
  }, [clickedKeyCode, onCancel, onConfirm]);

  return (
    <section className="ConfirmPopUp">
      <div className="ConfirmPopUp_Title">{title}</div>
      <div className="ConfirmPopUp_Buttons">
        <button
          className={classNames({
            'ConfirmPopUp_Buttons_Button ConfirmPopUp_Buttons_Confirm': true,
            ConfirmPopUp_Buttons_Button_Disabled: pendingPolygonDelete
          })}
          onClick={onConfirm}
        >
          {confirmText}
        </button>

        <button className="ConfirmPopUp_Buttons_Button ConfirmPopUp_Buttons_Cancel" onClick={onCancel}>
          {cancelText}
        </button>
      </div>
    </section>
  );
};

export default ConfirmPopUp;
